import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledPageTitle, StyledPageSubTitle } from 'theme/styles';
import { Grid } from '@mui/material';
import { AccountType } from 'constants/AccountType';
import { EButtonVariants } from 'constants/Buttons';
import Button from 'components/atoms/Button';
import { DashboardBeforeYouApply } from 'pages/DashboardPage/DashboardBeforeYouApply';
import { DashboardApplyforLicence } from 'pages/DashboardPage/DashboardApplyforLicence';
import { DashboardAdditionalGuidance } from 'pages/DashboardPage/DashboardAdditionalGuidance';
import { DashboardGeneralEnquiries } from 'pages/DashboardPage/DashboardGeneralEnquiries';
import { LoginOption, LoginOptionItem, StyledContainerAccountTypes } from './styles';

export interface IAccountTypePage {
  login: (type: AccountType) => void;
  signIn: (type: AccountType) => void;
}
const AccountTypePage = ({ login, signIn }: IAccountTypePage): ReactElement => {
  const { t } = useTranslation();

  return (
    <Grid container rowGap="40px">
      <Grid container item xs={12}>
        <Grid container item xs={12}>
          <StyledPageTitle variant="h4">{t('page.signin.title')}</StyledPageTitle>
        </Grid>
        <Grid container item xs={12}>
          <StyledPageSubTitle variant="h5">{t('page.signin.subtitle')}</StyledPageSubTitle>
        </Grid>
      </Grid>
      <StyledContainerAccountTypes item xs={12} gap={4}>
        <LoginOption item xs={12} xl={5.8}>
          <LoginOptionItem item xs={12}>
            <StyledPageTitle variant="h4">{t('page.signin.individual.name')}</StyledPageTitle>
            <StyledPageSubTitle variant="h5">
              {t('page.signin.individual.description')}
            </StyledPageSubTitle>
          </LoginOptionItem>
          <LoginOptionItem item xs={12}>
            <Button
              id="login-individual"
              label={t('page.signin.button.login')}
              variant={EButtonVariants.contained}
              fullWidth
              onClick={() => login(AccountType.individual)}
            />
            <Button
              id="create-individual"
              label={t('page.signin.button.createAccount')}
              variant={EButtonVariants.text}
              fullWidth
              onClick={() => signIn(AccountType.individual)}
            />
          </LoginOptionItem>
        </LoginOption>
        <LoginOption item xs={12} xl={5.8}>
          <LoginOptionItem item xs={12}>
            <StyledPageTitle variant="h4">
              {t('page.signin.organisation.name')}
            </StyledPageTitle>
            <StyledPageSubTitle variant="h5">
              {t('page.signin.organisation.description')}
            </StyledPageSubTitle>
          </LoginOptionItem>
          <LoginOptionItem item xs={12}>
            <Button
              id="login-organisation"
              label={t('page.signin.button.login')}
              variant={EButtonVariants.contained}
              fullWidth
              onClick={() => login(AccountType.organisation)}
            />
            <Button
              id="create-organisation"
              label={t('page.signin.button.createAccount')}
              variant={EButtonVariants.text}
              fullWidth
              onClick={() => signIn(AccountType.organisation)}
            />
          </LoginOptionItem>
        </LoginOption>
      </StyledContainerAccountTypes>
      <DashboardBeforeYouApply />
      <DashboardApplyforLicence />
      <DashboardAdditionalGuidance />
      <DashboardGeneralEnquiries />
    </Grid>
  );
};

export { AccountTypePage };
